module.exports = __webpack_public_path__ + "assets/4202c653be7a0c72d80f2824921ed792.png";